import useDataLayer from "./hooks/useDataLayer";
import currency from "currency.js";
import {buildAnalyticsCategory} from "./helpers/analyticsHelpers";

const { pushToDataLayer } = useDataLayer();

const MAIN_METRIKA_ID = process.env.REACT_APP_YA_ID;


export const sendAnalyticsEvents = (target, step) => {
    sendAnalyticsEvent('yandex', target);
    sendAnalyticsEvent('facebook', null, step);
    sendAnalyticsEvent('vk_ads_1', null, step);
    sendAnalyticsEvent('vk_ads_2', null, step);
    sendAnalyticsEvent('vk_targeting_1', null, step);
    sendAnalyticsEvent('vk_targeting_2', null, step);
}

const sendAnalyticsEvent = (platform, target, step) => {
    switch (platform) {
        case 'yandex':
            sendYandexMetrikaEvent(target);
            break;
        case 'facebook':
            sendFacebookEvent(step);
            break;
        case 'vk_ads_1':
            sendVkAds1Event(step);
            break;
        case 'vk_ads_2':
            sendVkAds2Event(step);
            break;
        case 'vk_targeting_1':
            sendVkTargeting1Event(step);
            break;
        case 'vk_targeting_2':
            sendVkTargeting2Event(step);
            break;
        default:
            console.warn(`Unknown platform: ${platform}`);
    }
};

const sendYandexMetrikaEvent = (target) => {
    let currentLocation = window.location.href;
    const paramsHandler = {
        date_main: { URL_Date: currentLocation, "277269962_to-parse": `${currentLocation};${Date.now()}` },
        name_main: { URL_Name: currentLocation, "289167522_to-parse": `${currentLocation};${Date.now()}` },
        confirm_main: { URL_Confirm: currentLocation, "289167723_to-parse": `${currentLocation};${Date.now()}` },
        purchase_main: { URL_Purchase: currentLocation, "277269964_to-parse": `${currentLocation};${Date.now()}` }
    };

    if (window.ym) {
        window.ym(MAIN_METRIKA_ID, 'reachGoal', target, paramsHandler[target] || {});
    } else {
        console.warn('Yandex Metrika is not loaded');
    }
};

const sendFacebookEvent = (step) => {
    if (window.fbq) {
        window.fbq('track', 'ViewContent', {
            content_name: 'pageview',
            content_category: `step_${step}`,
            value: 1.00,
            currency: 'EUR'
        });
    } else {
        console.warn('Facebook Pixel is not loaded');
    }
};

const sendVkAds1Event = (step) => {
    const VK_ADS_1_ID = process.env.REACT_APP_VK_ADS_1_ID;
    const _tmr = window._tmr || (window._tmr = []);

    if (_tmr) {
        _tmr.push({ id: VK_ADS_1_ID, type: 'reachGoal', goal: `pageview-step_${step}` });
    } else {
        console.warn('VK Ads (Кабинет 1) is not loaded');
    }
};

const sendVkAds2Event = (step) => {
    const VK_ADS_2_ID = process.env.REACT_APP_VK_ADS_2_ID;
    const _tmr = window._tmr || (window._tmr = []);

    if (_tmr) {
        _tmr.push({ type: 'reachGoal', id: VK_ADS_2_ID, goal: `pageview-step_${step}` });
    } else {
        console.warn('VK Ads (Кабинет 2) is not loaded');
    }
};

const sendVkTargeting1Event = (step) => {
    const VK_TARGETING_1_ID = process.env.REACT_APP_VK_TARGETING_1_ID;

    if (window.VK && window.VK.Retargeting) {
        window.VK.Retargeting.Init(VK_TARGETING_1_ID);
        window.VK.Retargeting.Event(`pageview-step_${step}`);
    } else {
        console.warn('VK Targeting (Старый кабинет 1) is not loaded');
    }
};

const sendVkTargeting2Event = (step) => {
    const VK_TARGETING_2_ID = process.env.REACT_APP_VK_TARGETING_2_ID;

    if (window.VK && window.VK.Retargeting) {
        window.VK.Retargeting.Init(VK_TARGETING_2_ID);
        window.VK.Retargeting.Event(`pageview-step_${step}`);
    } else {
        console.warn('VK Targeting (Старый кабинет 2) is not loaded');
    }
};

const staticCategoryUrl = {
    'Abonement': 'https://silavetra.com/abonement',
    'Certificate': 'https://silavetra.com/certificate',
}

export const sendYandexMetrikaEcommerceEvent = (eventName, eventData) => {
    if (window.ym) {
        window.ym(MAIN_METRIKA_ID, 'reachGoal', eventName, eventData);
    } else {
        console.warn('YM counter is not loaded');
    }
};

export const handleAddToCart = (product, categoryParams) => {
    const category = buildAnalyticsCategory(categoryParams);
    const isGiftOrSubscription = ['Certificate', 'Abonement'].includes(product.category);
    pushToDataLayer({
        ecommerce: {
            currencyCode: "RUB",
            add: {
                products: [{
                    id: isGiftOrSubscription ? staticCategoryUrl[product.category] : product.id,
                    name: isGiftOrSubscription ? product.category : product.name,
                    price: isGiftOrSubscription ? product.totalValue : product.price,
                    brand: "Сила ветра",
                    category,
                    quantity: product.quantity || 1,
                    list: "Booking",
                    variant: product.category === 'Certificate' ? product.name : undefined,
                    position: 1
                }]
            }
        }
    });
}

export const sendBookingEvent = (order, productType) => {
    if (!order?.id) return;

    const productData = getProductData(order, productType);

    const totalPaid = +order?.totalValue

    sendYandexMetrikaEcommerceEvent('start_order', {
        products: [
            {
                id: staticCategoryUrl[productData.name],
                name: productData.name,
                price: totalPaid,
                brand: "Сила ветра",
                category: productData.category,
                variant: productType === 'abonement' ? productData.name : undefined,
                list: "Booking",
                position: 1,
                quantity: order?.paidForLength || 1,
            }
        ],
        total: totalPaid,
        orderId: order.id,
    });
};

const getProductData = (order, productType) => {
    const category = buildAnalyticsCategory(order);

    const dataMap = {
        certificate: {
            id: 'certificate',
            name: order?.name,
            price: order?.totalValue,
            category,
        },
        abonement: {
            id: 'abonement',
            name: 'Abonement',
            price: order?.totalValue,
            category,
        }
    };

    return dataMap[productType];
};

export const handlePurchaseEvent = (product) => {
    const specialProductCategory = ['Certificate', 'Abonement'];
    const certificateOrAbonement = specialProductCategory.includes(product.name)
    const productCategory = certificateOrAbonement ? product.name : product.category;
    const isGiftOrSubscription = specialProductCategory.includes(productCategory);

    let totalPaid = product?.discountedValue
    const isAbonementApplied = !!product?.depositSum
    const isCertificateApplied = !!product?.certificateSum
    const isPartialPayment = !!product?.payments?.payment_size
    const isAbonementAppliedFull = totalPaid === product?.depositSum
    const quantity = product.quantity || 1

    const discountedValueForPerson = currency(totalPaid, {precision: 3, pattern: "#"}).divide(quantity).value;

    let paymentAmount = discountedValueForPerson;

    if (isAbonementApplied && isAbonementAppliedFull) {
        paymentAmount = currency(discountedValueForPerson).multiply(product.quantity).subtract(product?.depositSum).value
        totalPaid = paymentAmount
    } else if (isAbonementApplied && !isAbonementAppliedFull) {
        totalPaid = currency(totalPaid).subtract(product?.depositSum).value
        paymentAmount = currency(totalPaid).divide(product.quantity).value
    } else if (isCertificateApplied) {
        paymentAmount = discountedValueForPerson;
    } else if (isPartialPayment) {
        paymentAmount = currency(discountedValueForPerson, {precision: 3, pattern: "#"})
            .divide(100)
            .multiply(product?.payments?.payment_size)
            .value
        totalPaid = currency(paymentAmount).multiply(product.quantity).value
    }

    pushToDataLayer({
        ecommerce: {
            currencyCode: "RUB",
            purchase: {
                actionField: {
                    id: product.orderId,
                    revenue: totalPaid,
                },
                products: [
                    {
                        id: isGiftOrSubscription ? staticCategoryUrl[productCategory] : product.id,
                        name: product.name,
                        price: paymentAmount,
                        brand: "Сила ветра",
                        category: product.category || "Travel",
                        variant: product.name,
                        quantity: product.quantity || 1,
                        list: "Booking",
                        position: 1
                    }
                ]
            }
        }
    })
}

export const sendYandexMetrikaRgsEvent = (eventName, eventData = null) => {
    if (window.ym) {
        if (eventData) {
            window.ym(MAIN_METRIKA_ID, 'reachGoal', eventName, eventData);
        } else {
            window.ym(MAIN_METRIKA_ID, 'reachGoal', eventName);
        }
    } else {
        console.warn('Yandex Metrika is not loaded');
    }
};

export const handleClientParameters = (clientID) => {
    if (window.ym) {
        window.ym(MAIN_METRIKA_ID, 'userParams', {
            UserID: `${clientID}`
        });
    } else {
        console.warn('YM counter is not loaded');
    }
}